<script setup>
import BrandLockup from '@/Components/UI/BrandLockup.vue'

defineProps({
  homeHref:   { type: String, default: '/' },
  brandLabel: { type: String, default: 'Get Phuket' },
})
</script>

<template>
  <header class="brand-header">
    <div class="brand-header__inner">
      <a
        :href="homeHref"
        class="brand-header__brand"
        :aria-label="brandLabel"
      ><BrandLockup /></a>
      <slot name="nav" />
      <slot name="tools" />
    </div>
  </header>
</template>

<style scoped>
.brand-header { position: sticky; top: 0; z-index: 20; background: color-mix(in oklch, var(--surface) 88%, transparent); backdrop-filter: blur(8px); border-bottom: 1px solid var(--line); padding: 0.75rem clamp(1.25rem, 4vw, 3rem); padding-top: max(env(safe-area-inset-top), 0.75rem); }
.brand-header__inner { max-width: 96rem; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; gap: 1rem; }
.brand-header__brand { display: inline-flex; align-items: center; text-decoration: none; color: var(--ink); }
</style>
